// extracted by css-extract-rspack-plugin
export default {"container":"src-app-components-forms-ImageView-ImageView-module__container-k8XpuX","contents":"src-app-components-forms-ImageView-ImageView-module__contents-YM5h2f","image":"src-app-components-forms-ImageView-ImageView-module__image-iD572I","edit":"src-app-components-forms-ImageView-ImageView-module__edit-Yd0eOm","nothing":"src-app-components-forms-ImageView-ImageView-module__nothing-GMwt_l","footer":"src-app-components-forms-ImageView-ImageView-module__footer-PhVCuN"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"container\":\"src-app-components-forms-ImageView-ImageView-module__container-k8XpuX\",\"contents\":\"src-app-components-forms-ImageView-ImageView-module__contents-YM5h2f\",\"image\":\"src-app-components-forms-ImageView-ImageView-module__image-iD572I\",\"edit\":\"src-app-components-forms-ImageView-ImageView-module__edit-Yd0eOm\",\"nothing\":\"src-app-components-forms-ImageView-ImageView-module__nothing-GMwt_l\",\"footer\":\"src-app-components-forms-ImageView-ImageView-module__footer-PhVCuN\"}";
        // 1789362522818
        var cssReload = require("../../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  